// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item app-card-skeleton {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/pending-list-skeleton/pending-list-skeleton.component.scss"],"names":[],"mappings":"AACI;EACI,WAAA;AAAR","sourcesContent":["ion-item {\r\n    app-card-skeleton {\r\n        width: 100%;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
